import { useEffect, useState } from "react";
import axios from "axios";

/** Comerciales para los filtros de las listas del CRM, solo para quien ve todo (C3D-46). */
export default function useSalesOptions(enabled) {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        if (!enabled) return;
        axios.get("/projects/people-options/", { params: { kind: "sales" } })
            .then(({ data }) => setOptions(data.results.map((user) => ({ value: String(user.id), label: user.name || user.email }))))
            .catch(() => setOptions([]));
    }, [enabled]);
    return options;
}
